import * as React from 'react';
import { dots } from "./dots";

import './index.css';

class LoadingDots extends React.Component<any, any>{
  render() {
    const { show, children } = this.props;
    if (show) return (
      <div className="Loader__background">
        <div className="Loader__foreground">
          <div className="Loader__message">
            {dots}
          </div>
        </div>
      </div>
    )
    return <>{children}</>;
  }
}

export default LoadingDots;
